export const getSortedTestsByDate = (testsList) =>
    testsList.sort((a, b) => new Date(b.date) - new Date(a.date));
